import { GAME_SESSION_STATUS } from '@/constants/maze';

export const LIVE_GAME_BOOTSTRAP_MIN_UI_MS = 400;

export function delay(ms: number): Promise<void> {
  return new Promise((resolve) => {
    globalThis.setTimeout(resolve, ms);
  });
}

export function isTerminalGameStatus(status: number): boolean {
  return (
    status === GAME_SESSION_STATUS.ENDED ||
    status === GAME_SESSION_STATUS.EXPIRED ||
    status === GAME_SESSION_STATUS.RESULT_PROCESSING ||
    status === GAME_SESSION_STATUS.MANUALLY_ENDED
  );
}

export function resolveRoundsProgress(data: {
  status: number;
  totalRounds: number;
  completedBoards?: number;
}): { total: number; completed: number } {
  const total = Math.max(1, data.totalRounds);
  if (typeof data.completedBoards === 'number') {
    return {
      total,
      completed: Math.min(Math.max(0, data.completedBoards), total),
    };
  }
  if (data.status === GAME_SESSION_STATUS.ENDED) {
    return { total, completed: total };
  }
  return { total, completed: 0 };
}
